import React from "react";
import { Table, Button, Typography } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import Moment from "moment";
import { extendMoment } from "moment-range";
import Employee from "../../../components/tables/Employee";
import Date from "../../../components/tables/Date";
import { CloseOutlined } from "@ant-design/icons";
import ModalContentWrapper from "./ModalContentWrapper.style";

const moment = extendMoment(Moment);
const { Title, Text } = Typography;
const SingleEventsContent = (props) => {
  const { onMouseOver, onMouseOut, hide, handleContinue } = props;
  const single_events = useSelector(
    (state) => state.plan.activeSimulatedPlan.single_events
  );
  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);

  const intl = useIntl();
  const onContinue = () => {
    handleContinue();
    hide();
  };

  const onCancel = async () => {
    hide();
  };
  const columns = [
    {
      title: intl.formatMessage({
        id: "app.plans.singleEventsEmployeeName",
      }),
      dataIndex: "employee",
      render(text, record) {
        return <Employee record={record.employee} />;
      },
      width: "220px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.singleEventsDate",
      }),
      dataIndex: "date",
      render(text) {
        return <Date text={text} format={"L"} />;
      },
      width: "140px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.singleEventsStart",
      }),
      dataIndex: "date",
      render(text) {
        return <Date text={text} format={"HH:mm"} />;
      },
      width: "140px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.singleEventsEnd",
      }),
      dataIndex: "date",
      render(text, record) {
        return (
          <Date
            text={moment(text).add(record.duration_minutes, "minutes")}
            format={"HH:mm"}
          />
        );
      },
      width: "140px",
    },
  ];

  return (
    <ModalContentWrapper direction={currentAppLocale.direction}>
      <div className="top" onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <Button
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={hide}
        />
      </div>
      <div className="inner">
        <Title level={5}>
          {intl.formatMessage({
            id: "app.plans.singleEventsModalTitle",
          })}
        </Title>

        <div style={{ width: "640px" }}>
          <Table
            bordered
            dataSource={single_events}
            columns={columns}
            pagination={false}
            scroll={{
              y: window.innerHeight / 3,
            }}
          />
        </div>
        <div className="vertical-divider" />
        <Text>
          {intl.formatMessage({
            id: "app.plans.singleEventsModalDescription",
          })}
        </Text>
      </div>
      <div className="actions">
        <Button type="primary" onClick={onContinue}>
          {intl.formatMessage({
            id: "app.actions.continueWithoutSingleEvents",
          })}
        </Button>
        <div className="horizontal-divider" />
        <Button onClick={onCancel}>
          {intl.formatMessage({
            id: "app.actions.cancel",
          })}
        </Button>
      </div>
    </ModalContentWrapper>
  );
};

export default SingleEventsContent;
